import React from 'react';

// Step colours in the Ride Inspection timeline.
export const TONE_COLOR = {
  done: '#10b981',
  active: '#38bdf8',
  cancelled: '#ef4444',
  warn: '#f59e0b',
  note: '#64748b',
};

/**
 * The stepped list in Ride Inspection. Purely presentational: `view` comes from
 * buildRideTimeline (utils/rideTimeline.js) and `formatTime` from the admin
 * firebase service, so this renders the same in the app and in a test harness.
 */
export default function RideTimelineList({ view, formatTime }) {
  const { steps, notice } = view;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12, padding: '8px 12px' }}>
      {notice && (
        <div className="muted" style={{ fontSize: 12, padding: '8px 12px', borderRadius: 8, border: '1px dashed #334155' }}>
          {notice}
        </div>
      )}
      {steps.map((step, idx) => {
        const note = step.tone === 'note';
        return (
          <div key={step.id} style={{ display: 'flex', gap: 14, alignItems: 'flex-start' }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <div style={{
                width: note ? 24 : 32,
                height: note ? 24 : 32,
                marginTop: note ? 4 : 0,
                borderRadius: '50%',
                background: TONE_COLOR[step.tone] || TONE_COLOR.done,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: note ? 12 : 15, color: '#fff',
              }}>
                {step.icon}
              </div>
              {idx < steps.length - 1 && (
                <div style={{ width: 2, height: 28, background: '#334155', margin: '4px 0' }} />
              )}
            </div>
            <div style={{ flex: 1, paddingBottom: 8 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12 }}>
                <strong style={{ fontSize: note ? 13 : 14, color: note ? '#cbd5e1' : '#f8fafc' }}>{step.title}</strong>
                <span className="mono muted" style={{ fontSize: 11, whiteSpace: 'nowrap' }}>
                  {step.atMs != null ? formatTime(step.atMs) : 'now'}
                </span>
              </div>
              {step.subtitle && <p style={{ margin: '2px 0 0', fontSize: 12, color: '#cbd5e1' }}>{step.subtitle}</p>}
            </div>
          </div>
        );
      })}
    </div>
  );
}
